import { SimpleEntityGridActionCellButton } from "src/app/components/grid/CellRenderer/SimpleEntityGridActionCell/SimpleEntityGridActionCell";
import { UserRole } from "src/app/transports/user";
import { UserModel } from "src/app/types/UserModel";
import { JarvisSuggestionType, WritingType } from "src/app/types/orders/order";
import { StockOrder } from "src/app/types/orders/stockOrderPage";

export default function useStockGridActions(currentUser: UserModel) {
    const actions: SimpleEntityGridActionCellButton[] = [];

    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_BUSINESS_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_BUSINESS_MANAGER
    ) {
        actions.push("edit");
        actions.push("disable");
        actions.push("sendText");
    }

    actions.push("AIGuide");

    if (
        currentUser.role == UserRole.ROLE_BUSINESS_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_BUSINESS_MANAGER
    ) {
        actions.push("addUrl");
    }

    const sendTextCondition = (data: StockOrder): boolean => {
        return (
            (!data.writerNeeded && data.writingType !== WritingType.AI_AUTO) ||
            data.writingType === WritingType.AI_MANUAL
        );
    };

    const addAITitleCondition = (data: StockOrder): boolean => {
        return (
            (currentUser.role === UserRole.ROLE_ADMIN ||
                currentUser.role === UserRole.ROLE_LEAD_PROJECT_MANAGER ||
                currentUser.role === UserRole.ROLE_PROJECT_MANAGER ||
                currentUser.role === UserRole.ROLE_LEAD_WORKER ||
                currentUser.role === UserRole.ROLE_WORKER ||
                currentUser.role === UserRole.ROLE_BUSINESS_MANAGER ||
                currentUser.role === UserRole.ROLE_LEAD_BUSINESS_MANAGER) &&
            data.writingType === WritingType.AI_AUTO &&
            !data.title
        );
    };

    const AIGuideCondition = (data: StockOrder): boolean => {
        return (
            data.writingType === WritingType.AI_MANUAL &&
            !!data.keywords &&
            data.keywords.length > 0
        );
    };

    const addAIPlanCondition = (data: StockOrder): boolean => {
        return (
            (currentUser.role === UserRole.ROLE_ADMIN ||
                currentUser.role === UserRole.ROLE_LEAD_PROJECT_MANAGER ||
                currentUser.role === UserRole.ROLE_PROJECT_MANAGER ||
                currentUser.role === UserRole.ROLE_LEAD_WORKER ||
                currentUser.role === UserRole.ROLE_WORKER ||
                currentUser.role === UserRole.ROLE_BUSINESS_MANAGER ||
                currentUser.role === UserRole.ROLE_LEAD_BUSINESS_MANAGER) &&
            data.writingType === WritingType.AI_AUTO &&
            !!data.title &&
            !data.commentForWriter
        );
    };
    const addAITitleDisableCondition = (data: any): boolean => {
        return (
            !data.jarvisSuggestion ||
            (!!data.jarvisSuggestion && data.jarvisSuggestion?.length == 0) ||
            !(
                (data.jarvisSuggestion?.length > 0 &&
                    data.jarvisSuggestion[0].type === JarvisSuggestionType.TITLE) ||
                (data.jarvisSuggestion?.length === 2 &&
                    data.jarvisSuggestion[1].type === JarvisSuggestionType.TITLE)
            )
        );
    };

    const addAIPlanDisableCondition = (data: any): boolean => {
        return (
            !data.title ||
            !data.jarvisSuggestion ||
            (!!data.jarvisSuggestion && data.jarvisSuggestion?.length == 0) ||
            !(
                (data.jarvisSuggestion?.length > 0 &&
                    data.jarvisSuggestion[0].type === JarvisSuggestionType.PLAN) ||
                (data.jarvisSuggestion?.length === 2 &&
                    data.jarvisSuggestion[1].type === JarvisSuggestionType.PLAN)
            )
        );
    };

    return {
        actions,
        addAITitleCondition,
        addAIPlanCondition,
        sendTextCondition,
        addAITitleDisableCondition,
        addAIPlanDisableCondition,
        AIGuideCondition,
    };
}
